var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"url":_vm.url,"fileName":_vm.fileName,"extendName":_vm.extendName,"canRemove":_vm.canRemove,"canDownload":_vm.canDownload,"canPreview":_vm.canPreview},on:{"remove":_vm.remove,"download":_vm.download,"preview":_vm.preview},scopedSlots:_vm._u([{key:"previewFileItem",fn:function(ref){
var url = ref.url;
var fileName = ref.fileName;
var extendName = ref.extendName;
return (_vm.$scopedSlots.previewFileItem)?[_vm._t("previewFileItem",null,{url:url,fileName:fileName,extendName:extendName})]:undefined}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347516cb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/public/components/kye-preview/component/index.vue
// module id = null
// module chunks = 